import './first.component.js';
import './founders.component.js';
import './our-process.component.js';
import './contact.component.js';